<app-preview-error
    class="preview-file"
    *ngIf="!initialized && errcode"
    [errcode]="errcode"
    [syncId]="locId"
    [item]="item"
></app-preview-error>

<app-preview-error
    class="preview-file"
    *ngIf="initialized && errcode"
    [errcode]="errcode"
    [syncId]="locId"
    [item]="item"
></app-preview-error>

<app-preview-image
    class="preview-file"
    *ngIf="type === 'image' && initialized"
    [item]="item"
    [list]="list"
    [syncId]="locId"
    (getCurrentFile)="getCurrentFile($event)"
></app-preview-image>

<app-preview-video 
    class="preview-file"
    *ngIf="type === 'video' && initialized" 
    [videoUrl]="url"
    [mimeType]="mimeType"
    [item]="item"
></app-preview-video>

<app-preview-default
    class="preview-file"
    *ngIf="type === 'default' && initialized"
    [item]="item"
    [upsell]="upsell"
    [notice]="notice"
></app-preview-default>

<app-preview-doc
    class="preview-file"
    *ngIf="type === 'doc' && initialized"
    [item]="item"
    (stateChange)="onStateChange($event)"
></app-preview-doc>

<app-preview-text
    class="preview-file"
    *ngIf="type === 'text' && initialized"
    [item]="item"
></app-preview-text>

<app-preview-audio 
    class="preview-file"
    *ngIf="type === 'audio' && initialized" 
    [audioUrl]="url"
    [mimeType]="mimeType"
    [item]="item"
></app-preview-audio>

<app-preview-wopi
    class="preview-file"
    *ngIf="
    (type === 'office' || type === 'officefse' || type === 'officefsv')
    && initialized"
    [item]="item"
    (stateChange)="onStateChange($event)"
></app-preview-wopi>